<template>
    <page-shell title="Applications">
        <div v-if="!loading" class="applications">
            <el-table @row-click="openApplication" :data="apps" height="calc(100vh - 300px)" width="100%"
                :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column prop="repository" label="Name" sortable>
                </el-table-column>
                <el-table-column label="For"
                    :filters="[{ text: 'XCube', value: 'xcube' }, { text: 'XPod', value: 'xpod' }, { text: 'XKiosk', value: 'xkiosk' }, { text: 'XTend', value: 'xtend' }]"
                    :filter-method="filterFor">
                    <template slot-scope="scope">
                        <span class="hub-tags">
                            <el-tag v-if="scope.row.type_for_xpod || scope.row.flexible" disable-transitions>XPOD</el-tag>
                            <el-tag v-if="scope.row.type_for_xkiosk || scope.row.flexible" disable-transitions>XKIOSK</el-tag>
                            <el-tag v-if="scope.row.type_for_xcube || scope.row.flexible" disable-transitions>XCUBE</el-tag>
                            <el-tag v-if="scope.row.type_for_xtend || scope.row.flexible" disable-transitions>XTEND</el-tag>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <spinner :loading="loading" text="Loading applications..."></spinner>
    </page-shell>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getApplications } from "../../api/graphql/applications";
import PageShell from "../shared/PageShell.vue";
import Spinner from "../shared/Spinner.vue";
import { useRouter } from "vue-router/composables";

const router = useRouter();
const apps = ref([]);
const loading = ref(false);

const openApplication = (row) => {
    router.push({ name: "application", params: { id: row.id } });
};

const filterFor = (value, row) => {
    return row[`type_for_${value}`];
};

onMounted(async () => {
    loading.value = true;
    apps.value = await getApplications();
    loading.value = false;
});
</script>

<style scoped lang="scss">
.applications {
    width: 100%;
    min-width: 0;

    .el-table {
        cursor: pointer;
        width: 100%;
    }
}
</style>